<template>
  <!-- TODO: This component needs an "unable to load" state -->
  <div>
    <a
      class="maxpreps-widget-link"
      :data-width="width"
      :data-height="height"
      :data-type="type"
      :data-member-id="memberId"
      :data-allow-scrollbar="allowScrollbar"
      :href="href"
    >
      {{ title }}
    </a>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      required: false,
      default: 900,
    },
    height: {
      type: Number,
      required: false,
      default: 600,
    },
    type: {
      type: String,
      required: false,
      default: 'tournament',
    },
    memberId: {
      type: String,
      required: true,
    },
    allowScrollbar: {
      type: Boolean,
      required: false,
      default: true,
    },
    href: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
  },
  created() {
    let d = document;
    if (!d.getElementById('maxPrepsWidget')) {
      let mp = d.createElement('script');
      let h = d.getElementsByTagName('head')[0];
      mp.type = 'text/javascript';
      mp.id = 'maxPrepsWidget';
      mp.async = true;
      mp.src =
        'https://www.maxpreps.com/includes/js/widget/widget.compressed.js';
      h.appendChild(mp);
    }
  },
};
</script>
